import { Binder, DataProvider, Req } from "badmfck-signal";
import { IExecutorResponse } from "badmfck-signal/dist/DataProvider";
import { GD } from "../GD";

export class Common {
	currencies: DataProvider<void, ICurrency[]> = new DataProvider(
		{ cacheTime: 10_000 },
		"Currencies"
	);

	cardTypes: DataProvider<void, ICardType[]> = new DataProvider(
		{ cacheTime: 10_000 },
		"CardTypes"
	);

	constructor() {
		this.currencies.setExecutor(this.getDefs);
		CommonDispatcher.B_DEFS.onRequest(async () =>
			CommonDispatcher.B_DEFS.invoke(await this.currencies.load())
		);

		this.cardTypes.setExecutor(this.getCardTypes);
		CommonDispatcher.B_CARD_TYPES.onRequest(async () =>
			CommonDispatcher.B_CARD_TYPES.invoke(await this.cardTypes.load())
		);

		CommonDispatcher.REQ_COMMENTS.listener = async req =>
			this.getComments(req);

		CommonDispatcher.REQ_COMMENT_ADD.listener = async req =>
			this.addComment(req);
	}

	async addComment(req: {
		targetType: string;
		targetId?: number;
		sectionType: number;
		value: string;
		files?: File[];
	}): Promise<IAPIResponse<IComment> | null> {
		const goup = await GD.REQ_API.request({
			method: "comments/add",
			data: {
				section_id: req.sectionType,
				target_id: req.targetId,
				target_type: req.targetType,
				text: req.value,

			},
			files: req.files,
		});

		return goup;
	}

	async getComments(req: {
		targetType: string;
		targetId?: number;
		sectionType: number;
	}): Promise<IAPIResponse<IComment[]> | null> {
		const comments = await GD.REQ_API.request({
			method: "comments/list",
			data: {
				section_id: req.sectionType,
				target_id: req.targetId,
				target_type: req.targetType,
			},
		});
		// if(comments.data)
		// {
		// 	return comments.data;
		// }

		return comments;
	}

	private getDefs = async (): Promise<IExecutorResponse<ICurrency[]>> => {
		return GD.REQ_API.request({
			method: "defs/get/currencies",
			data: null,
		}) as Promise<IExecutorResponse<ICurrency[]>>;
	};

	private getCardTypes = async (): Promise<
		IExecutorResponse<ICardType[]>
	> => {
		return GD.REQ_API.request({
			method: "defs/get/card/types",
			data: null,
		}) as Promise<IExecutorResponse<ICardType[]>>;
	};
}

export class CommonDispatcher {
	static B_DEFS = new Binder<void, IExecutorResponse<ICurrency[]>>("B_DEFS");
	static B_CARD_TYPES = new Binder<void, IExecutorResponse<ICardType[]>>(
		"B_CARD_TYPES"
	);

	static REQ_COMMENTS = new Req<
		{ targetType: string; targetId?: number; sectionType: number, limit?: number },
		IAPIResponse<IComment[]> | null
	>(undefined, "REQ_COMMENTS");

	static REQ_COMMENT_ADD = new Req<
		{
			targetType: string;
			targetId?: number;
			sectionType: number;
			value: string;
			files?: File[];
		},
		IAPIResponse<IComment> | null
	>(undefined, "REQ_COMMENT_ADD");
}
